enum EnumRatePoint {
  SOB = 'sob',
  DISAPPOINTED = 'disappointed',
  NEUTRAL_FACE = 'neutral_face',
  SMILEY = 'smiley',
  STAR_STRUCK = 'star-struck',
}

export const emojiList: string[] = [
  EnumRatePoint.SOB,
  EnumRatePoint.DISAPPOINTED,
  EnumRatePoint.NEUTRAL_FACE,
  EnumRatePoint.SMILEY,
  EnumRatePoint.STAR_STRUCK,
];

export const getEmoji = (value: number): string => {
  const icon = emojiList[Math.floor(value) - 1];
  return icon !== undefined ? icon : EnumRatePoint.NEUTRAL_FACE;
};
